let opening;
function db() {
  if (!opening) opening = new Promise((resolve, reject) => {
    if (!window.indexedDB) { reject(new Error('Браузер не поддерживает сохранение очереди')); return; }
    const req = indexedDB.open('planium-storage-uploads', 1);
    req.onupgradeneeded = () => req.result.createObjectStore('jobs', { keyPath: 'id' });
    req.onsuccess = () => resolve(req.result); req.onerror = () => reject(req.error);
    req.onblocked = () => reject(new Error('Закройте старые вкладки, чтобы обновить очередь'));
  });
  return opening;
}
export async function store(action, value) {
  const database = await db();
  return new Promise((resolve, reject) => {
    const tx = database.transaction('jobs', action === 'all' ? 'readonly' : 'readwrite');
    const rows = tx.objectStore('jobs');
    const req = action === 'all' ? rows.getAll() : action === 'put' ? rows.put(value) : rows.delete(value);
    let result; req.onsuccess = () => { result = req.result; };
    tx.oncomplete = () => resolve(result); tx.onerror = () => reject(tx.error); tx.onabort = () => reject(tx.error);
  });
}